$(function (){
  responsiveNav();

  $('.carousel').slick({
    infinite: false,
    autoplay: true,
    dots: true,
    fade: true,
    arrows: false,
    mobileFirst: true,
    speed: 1000,
    autoplaySpeed: 2000,
    waitForAnimate: false
  });

  $('.gallery').imagesLoaded( function() {
    $('.gallery').masonry({
      itemSelector: '.grid-item',
      columnWidth: '.grid-sizer',
      percentPosition: true
    });
  });

  $('.grid-item > a').on('click', function() {
    $('#gallery-modal .modal-body > img').attr('src', $(this).data('src'));
  });
});

$(window).on('resize', responsiveNav);

function responsiveNav() {
  $('.menu-item-has-children').off('click hover');

  if ($(window).width() < 992) {

    $('.menu-item-has-children').on('click', function (event) {
      event.stopPropagation();
      $(this).toggleClass('opened');
      $(this).find('.sub-menu').slideToggle(250);
    });

  } else {

    $('.menu-item-has-children').on('hover', function (event) {
      $self = $(this);
      $self.addClass('opened');
      $self.find('.sub-menu').slideToggle(250, function(){
        $self.removeClass('opened');
      });
    });

  }
}
